var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

// テスト
var _isTest = false;

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

$(window).on('resize load' , function() {
  if(windowW <= 1024){
    _isSP = true;
  } else {
    _isSP = false;
  };

  //リサイズ処理 ブレイクポイントを跨いだらリロード
  var nowWidth = window.innerWidth;
  if(prewidth !== nowWidth){
    if(prewidth < 1025) {
      if(nowWidth >= 1025){
        location.reload();
      }
    }else {
      if(nowWidth < 1025){
        location.reload();
      }
    }
  };
});

$(window).on('load' , function() {

  scrollCommonAnime();

});


// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();

  const targets = document.querySelectorAll(".sw-Ttl");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
  const scene = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: 1
    })
    .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
      // console.log("Scene entered.");
      $(target).addClass("is-animated");
      setTimeout(function(){
        $(target).children(".en").textyle(
          {
            duration : 500, //エフェクト時間(ミリ秒)
            delay : 40, //文字間のエフェクト間隔(ミリ秒)
            // easing : 'swing', //エフェクトのイージングパターン
            callback : function(){
              $(target).addClass("is-completed");
            }
          }
        );
      },300);
    })
    // .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};



// WEBPACK FOOTER //
// ./src/marginal4_v0/assets/js/common/script.js